import React from "react";
import { Provider } from "react-redux";
import Store from "./Redux/Store";
import Weather from "./Components/Weather";

const App = () =>  {
    return (
        <Provider store={Store}>
            <Weather />
        </Provider>
    )
}

export default App